import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";

export const ThemeToggle = ({ className }: { className?: string }) => {
  const { theme, resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  const current = mounted ? (theme === "system" ? resolvedTheme : theme) : "light";
  const isDark = current === "dark";

  return (
    <button
      type="button"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      aria-label={isDark ? "Activer le mode clair" : "Activer le mode sombre"}
      title={isDark ? "Mode clair" : "Mode sombre"}
      className={cn(
        "inline-flex size-10 items-center justify-center rounded-sm border border-border/70 bg-background/40 text-foreground/80 transition-all hover:border-border hover:text-foreground",
        className,
      )}
    >
      <Sun
        className={cn(
          "size-[18px] transition-all",
          isDark ? "absolute rotate-90 scale-0" : "rotate-0 scale-100",
        )}
      />
      <Moon
        className={cn(
          "size-[18px] transition-all",
          isDark ? "rotate-0 scale-100" : "absolute -rotate-90 scale-0",
        )}
      />
    </button>
  );
};
